module.exports = __webpack_public_path__ + "img/intro3.95d313bc.gif";